import { PropsWithChildren, useState } from 'react'

import { useParams } from 'react-router-dom'

import { DeviceIdContext } from './DeviceIdContext'

export function DeviceIdProvider({ children }: PropsWithChildren) {
  const params = useParams()

  const [deviceId, setDeviceId] = useState<string | undefined>(params.deviceId)

  return (
    <DeviceIdContext.Provider value={{ deviceId, setDeviceId }}>
      {children}
    </DeviceIdContext.Provider>
  )
}
